import * as Types from '../../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
import {
  AdobeProgramTrackingFragment,
  AdobeNodeTrackingFragment,
  AdobeTrackingFragment,
  NielsenTrackingFragment,
  LiveTrackingFragment,
} from './Tracking';
export type PlayUnifiedStartOverAvailableQueryVariables = Types.Exact<{
  transmissionId: Types.Scalars['String']['input'];
}>;

export type PlayUnifiedStartOverAvailableQuery = {
  epgEntry: {
    __typename: 'EpgTransmission';
    epg: {
      __typename: 'Epg';
      startOverAvailable: boolean;
      title: string | null;
      programStart: number | null;
    };
  } | null;
};

export type PlayUnifiedStartOverTrackingQueryVariables = Types.Exact<{
  guid: Types.Scalars['String']['input'];
  transmissionId: Types.Scalars['String']['input'];
  nielsenTrackingVersion?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type PlayUnifiedStartOverTrackingQuery = {
  tracking:
    | {
        __typename: 'LiveTracking';
        nielsen: {
          __typename: 'DetailedNielsenList';
          nodes: Array<{
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null> | null;
          active: {
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null;
        } | null;
        adobe: {
          __typename: 'DetailedAdobeBlockList';
          nodes: Array<{
            __typename: 'DetailedAdobeBlock';
            prerolls: {
              __typename: 'DetailedAdobeList';
              nodes: Array<{
                __typename: 'DetailedAdobe';
                id: string | null;
                title: string | null;
                duration: number | null;
                broadcast: string | null;
                ad: boolean | null;
                start: number | null;
                stop: number | null;
                startOverAvailable: boolean | null;
              } | null> | null;
            } | null;
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
          } | null> | null;
          active: {
            __typename: 'DetailedAdobeBlock';
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
          } | null;
        } | null;
      }
    | { __typename: 'VodTracking' }
    | null;
  epgEntry: {
    __typename: 'EpgTransmission';
    epg: {
      __typename: 'Epg';
      entityId: string | null;
      description: string | null;
      imageUrl: string | null;
      live: boolean | null;
      programStart: number | null;
      programStop: number | null;
      start: number | null;
      startOverAvailable: boolean;
      stop: number | null;
      synopsis: string | null;
      title: string | null;
      transmissionId: string | null;
      vodAvailableStart: number | null;
      vodAvailableStop: number | null;
    };
  } | null;
};

export type StartOverInformationFragment = {
  __typename: 'Epg';
  entityId: string | null;
  title: string | null;
  start: number | null;
  stop: number | null;
  startOverAvailable: boolean;
  vodAvailableStart: number | null;
  vodAvailableStop: number | null;
  transmissionId: string | null;
  imageUrl: string | null;
  entity:
    | { __typename: 'Broadcast'; guid: string }
    | { __typename: 'Episode'; guid: string }
    | { __typename: 'Event'; guid: string }
    | { __typename: 'Movie'; guid: string }
    | { __typename: 'Program'; guid: string }
    | { __typename: 'Series'; guid: string }
    | { __typename: 'SportingEvent'; guid: string }
    | { __typename: 'Station'; guid: string }
    | null;
};

export const StartOverInformationFragment = gql`
  fragment startOverInformationFragment on Epg {
    __typename
    entityId
    title
    start
    stop
    startOverAvailable
    vodAvailableStart
    vodAvailableStop
    transmissionId
    imageUrl
    entity {
      guid
    }
  }
`;
export const PlayUnifiedStartOverAvailable = gql`
  query play_unified_start_over_available($transmissionId: String!) {
    epgEntry(transmissionId: $transmissionId) {
      epg {
        startOverAvailable
        title
        programStart
      }
    }
  }
`;
export const PlayUnifiedStartOverTracking = gql`
  query play_unified_start_over_tracking(
    $guid: String!
    $transmissionId: String!
    $nielsenTrackingVersion: String
  ) {
    tracking(guid: $guid, nielsenVersion: $nielsenTrackingVersion) {
      ...liveTrackingFragment
    }
    epgEntry(transmissionId: $transmissionId) {
      epg {
        entityId
        description
        imageUrl
        live
        programStart
        programStop
        start
        startOverAvailable
        stop
        synopsis
        title
        transmissionId
        vodAvailableStart
        vodAvailableStop
      }
    }
  }
  ${LiveTrackingFragment}
  ${NielsenTrackingFragment}
  ${AdobeTrackingFragment}
  ${AdobeNodeTrackingFragment}
  ${AdobeProgramTrackingFragment}
`;
